import moment from 'moment';

// Meeus/Jones/Butcher algorithm for the Gregorian Easter Sunday
function getEasterSunday(year) {
    var f = Math.floor,
        G = year % 19,
        C = f(year / 100),
        H = (C - f(C / 4) - f((8 * C + 13) / 25) + 19 * G + 15) % 30,
        I = H - f(H / 28) * (1 - f(29 / (H + 1)) * f((21 - G) / 11)),
        J = (year + f(year / 4) + I + 2 - C + f(C / 4)) % 7,
        L = I - J,
        month = 3 + f((L + 40) / 44),
        day = L + 28 - 31 * f(month / 4);
    return moment([year, month - 1, day]);
}

function nthWeekdayOfMonth(year, month, weekday, n) {
    // month is 0-indexed, weekday: 0=Sunday...6=Saturday
    var date = moment([year, month, 1]);
    var add = (weekday - date.day() + 7) % 7;
    date.add(add + (n - 1) * 7, 'days');
    return date;
}

function lastWeekdayOnOrBefore(year, month, day, weekday) {
    var date = moment([year, month, day]);
    while (date.day() !== weekday) {
        date.subtract(1, 'day');
    }
    return date;
}

export function getNBHolidays(year) {
    return [
        {key: 'new_years_day', name: "New Year's Day", date: moment([year, 0, 1])},
        {key: 'good_friday', name: "Good Friday", date: getEasterSunday(year).subtract(2, 'days')},
        {key: 'victoria_day', name: "Victoria Day", date: lastWeekdayOnOrBefore(year, 4, 24, 1)},
        {key: 'canada_day', name: "Canada Day", date: moment([year, 6, 1])},
        {key: 'labour_day', name: "Labour Day", date: nthWeekdayOfMonth(year, 8, 1, 1)},
        {key: 'truth_reconciliation', name: "National Day for Truth and Reconciliation", date: moment([year, 8, 30])},
        {key: 'thanksgiving', name: "Thanksgiving Day", date: nthWeekdayOfMonth(year, 9, 1, 2)},
        {key: 'remembrance_day', name: "Remembrance Day", date: moment([year, 10, 11])},
        {key: 'christmas_day', name: "Christmas Day", date: moment([year, 11, 25])},
        {key: 'boxing_day', name: "Boxing Day", date: moment([year, 11, 26])},
    ].sort(function (a, b) {
        return a.date.diff(b.date);
    });
}
